import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/expand_more_black.svg'


const _withScopeId = n => (_pushScopeId("data-v-74440b9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-menu-main-div" }
const _hoisted_2 = {
  key: 0,
  class: "select-text small-text"
}
const _hoisted_3 = {
  key: 1,
  class: "select-text small-text"
}
const _hoisted_4 = {
  key: 2,
  class: "select-text small-text"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "select-icon",
  src: _imports_0
}, null, -1))
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'dropdown-for-actions',
        {
          'dropdown-for-actions-open': _ctx.show,
        },
      ]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDropdown && _ctx.showDropdown(...args)))
    }, [
      (!_ctx.num_actions_selected && _ctx.options_filled)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      (!_ctx.num_actions_selected && !_ctx.options_filled)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.labelSelectRole), 1))
        : _createCommentVNode("", true),
      (_ctx.num_actions_selected)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.labelWithActions) + _toDisplayString(_ctx.num_actions_selected), 1))
        : _createCommentVNode("", true),
      _hoisted_5
    ], 2),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass([
        'multiselect-actions',
        {
          'multiselect-actions-open': _ctx.show,
        },
      ])
    }, [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createVNode(_component_checkbox, {
                  class: "checkboxes",
                  id: index,
                  checkboxText: option.text,
                  checkActive: option.selected,
                  color: 'orange',
                  size: 'small',
                  onToggleCheckBox: ($event: any) => (_ctx.checkSelectedOption(option))
                }, null, 8, ["id", "checkboxText", "checkActive", "onToggleCheckBox"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2), [
      [_directive_click_away, _ctx.closeDropdown]
    ])
  ]))
}